import styled from 'styled-components';
import type { ThemeTypes } from '../../../../types/Theme.namespace';

export const ListItem = styled.li<{ $fontSize: ThemeTypes.FontSize }>`
  ${({ theme, $fontSize }) => theme.fontSize[$fontSize]};
  display: flex;
  flex: 1 0 auto;

  &:before {
    flex: 0 0 ${({ theme }) => theme.spacing.M24};
    content: '•';
    text-align: center;
  }
`;
